angular.module('app').config(creditPaymentTermsRouting);

function creditPaymentTermsRouting($routeProvider) {
  $routeProvider.when('/credit_payment_terms', {
    pageTitle: 'CREDIT_PAYMENT_TERMS',
    template: '<credit-payment-terms-page></credit-payment-terms-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    menu: 'settings',
    // accessPermission: 'index_creditpaymentterm_accountadmin', // TODO: pending in the api
    authReq: true,
  });
}

creditPaymentTermsRouting.$inject = ['$routeProvider'];
